import RequireNotAuth from "@/auth/components/RequireNotAuth";
import {
  ActivityCrumb,
  CheckpointCrumb,
  CourseCrumb,
  LessonCrumb,
  OrganizationCrumb,
  StandardCrumb,
} from "@/components/breadcrumbs";
import AcceptSiteInvitation from "@/pages/accept-invitation/AcceptSiteInvitation";
import AdminMain from "@/pages/admin/AdminMain";
import CheckpointDetailsView from "@/pages/checkpoint/CheckpointDetailsView";
import CourseOccasionsView from "@/pages/course-occasions/CourseOccasionsView";
import CourseSettingsView from "@/pages/course-settings/CourseSettingsView";
import CourseDetailsView from "@/pages/course/CourseDetailsView";
import { CourseMain } from "@/pages/course/CourseMain";
import { FilesViewPage } from "@/pages/files/FilesPageView";
import { ForgotPassword, ResetPassword } from "@/pages/forgot-password";
import LessonDetailsView from "@/pages/lesson/LessonDetailsView";
import Main from "@/pages/main/Main";
import OrganizationListView from "@/pages/organization/OrganizationListView";
import { OrganizationMain } from "@/pages/organization/OrganizationMain";
import { PerkDetailsView } from "@/pages/perks/PerkDetailsView";
import { PerkListView } from "@/pages/perks/PerkListView";
import PromptDetailsView from "@/pages/prompt/PromptDetailsView";
import { ResourceDetailsView } from "@/pages/resource/ResourceDetailsView";
import { SettingsView } from "@/pages/settings/SettingsView";
import { SignIn } from "@/pages/sign-in";
import { StructureView } from "@/pages/structure/StructureView";
import MediaDetailsView from "@/pages/video/MediaDetailsView";
import OrganizationSettingsView from "@/pages/organization/OrganizationSettingsView";
import { TopNavigation } from "@/top-navigation";
import RequireAuth from "@auth/components/RequireAuth";
import * as Sentry from "@sentry/react";
import { createBrowserRouter, Outlet } from "react-router-dom";
import CourseListView from "./pages/course/CourseListView";
import { MaintenanceView } from "./pages/maintenance/MaintenanceView";
import { UserCreateView } from "./pages/user/UserCreateView";
import { UserDetailView } from "./pages/user/UserDetailView";
import { UsersWithDetailView } from "./pages/user/UsersWithDetailView";
const sentryCreateBrowserRouter =
  Sentry.wrapCreateBrowserRouter(createBrowserRouter);

export const router = sentryCreateBrowserRouter([
  {
    path: "/",
    element: (
      <RequireAuth>
        <Main />
      </RequireAuth>
    ),
    handle: {
      crumb: () => <StandardCrumb name="Home" />,
    },
    children: [
      { index: true, element: <OrganizationListView /> },
      {
        path: "admin",
        // handle: { crumb: () => <StandardCrumb name="Admin" /> },
        children: [
          {
            path: "maintain",
            element: <AdminMain />,
            handle: { crumb: () => <StandardCrumb name="Maintenance" /> },
          },
          {
            path: "settings",
            element: <SettingsView />,
            handle: { crumb: () => <StandardCrumb name="Settings" /> },
          },
          {
            path: "maintenance",
            element: <MaintenanceView />,
            handle: { crumb: () => <StandardCrumb name="Maintenance" /> },
          },
          {
            path: "admins",
            id: "admin-list",
            element: <UsersWithDetailView routeId="admin-list" />,
            handle: { crumb: () => <StandardCrumb name="All Users" /> },
            children: [
              {
                path: "create",
                element: <UserCreateView />,
                handle: { crumb: () => <StandardCrumb name="Create User" /> },
              },
              {
                path: ":userId",
                element: <UserDetailView />,
                // handle: { crumb: () => <StandardCrumb name="User Details" /> },
              },
            ],
          },
        ],
      },
      {
        path: "organization/:organizationId",
        handle: { crumb: () => <OrganizationCrumb /> },
        element: <OrganizationMain />,
        children: [
          { index: true, element: <CourseListView /> },
          {
            path: "courses",
            element: <StructureView />,
            handle: { crumb: () => <StandardCrumb name="Courses" /> },
          },
          {
            path: "files",
            element: <FilesViewPage />,
            handle: { crumb: () => <StandardCrumb name="Files" /> },
          },
          {
            path: "settings",
            element: <OrganizationSettingsView />,
            handle: { crumb: () => <StandardCrumb name="Organization Settings" /> },
          },
          {
            path: "admins",
            id: "organization-admin-list",
            element: <UsersWithDetailView routeId="organization-admin-list" />,
            handle: { crumb: () => <StandardCrumb name="Organization Users" /> },
            children: [
              {
                path: "create",
                element: <UserCreateView />,
                handle: { crumb: () => <StandardCrumb name="Create User" /> },
              },
              {
                path: ":userId",
                element: <UserDetailView />,
                // handle: { crumb: () => <StandardCrumb name="User Details" /> },
              },
            ],
          },
          {
            path: "course/:courseId",
            element: <CourseMain />,
            handle: { crumb: () => <CourseCrumb /> },
            children: [
              { index: true, element: <CourseDetailsView /> },
              {
                path: "perks",
                element: <Outlet />,
                handle: { crumb: () => <StandardCrumb name="Marketplace Prizes" /> },
                children: [
                  {
                    index: true,
                    element: <PerkListView />,
                  },
                  {
                    path: ":perkId",
                    element: <PerkDetailsView />,
                    handle: { crumb: () => <StandardCrumb name="Prize Details" /> },
                  },
                    ]
              },
              {
                path: "admins",
                id: "course-admin-list",
                element: <UsersWithDetailView routeId="course-admin-list" />,
                handle: { crumb: () => <StandardCrumb name="Course Users" /> },
                children: [
                  {
                    path: "create",
                    element: <UserCreateView />,
                    handle: { crumb: () => <StandardCrumb name="Create User" /> },
                  },
                  {
                    path: ":userId",
                    element: <UserDetailView />,
                    // handle: { crumb: () => <StandardCrumb name="User Details" /> },
                  },
                ],
              },
        
              {
                path: "checkpoint/:checkpointId",
                handle: { crumb: () => <CheckpointCrumb /> },
                children: [
                  { index: true, element: <CheckpointDetailsView /> },
                  {
                    path: ":lessonId",
                    handle: { crumb: () => <LessonCrumb /> },
                    children: [
                      { index: true, element: <LessonDetailsView /> },
                      {
                        path: "prompt/:promptId",
                        element: <PromptDetailsView />,
                        handle: { crumb: () => <ActivityCrumb /> },
                      },
                      {
                        path: "challenge/:promptId",
                        element: <PromptDetailsView />,
                        handle: { crumb: () => <ActivityCrumb /> },
                      },
                      {
                        path: "media/:mediaId",
                        element: <MediaDetailsView />,
                        handle: { crumb: () => <ActivityCrumb /> },
                      },
                      {
                        path: "resource/:resourceId",
                        element: <ResourceDetailsView />,
                        handle: { crumb: () => <ActivityCrumb /> },
                      },
                    ],
                  },
                ],
              },
              {
                path: "occasions",
                element: <CourseOccasionsView />,
                handle: { crumb: () => <StandardCrumb name="Class Schedule" /> },
              },
              {
                path: "settings",
                element: <CourseSettingsView />,
                handle: { crumb: () => <StandardCrumb name="Settings" /> },
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: TopNavigation.SignIn,
    element: (
      <RequireNotAuth>
        <SignIn />
      </RequireNotAuth>
    ),
  },
  {
    path: `${TopNavigation.AcceptInvitation}/:tokenId`,
    element: <AcceptSiteInvitation />,
  },
  {
    path: TopNavigation.ForgotPassword,
    element: (
      <RequireNotAuth>
        <ForgotPassword />
      </RequireNotAuth>
    ),
  },
  {
    path: `${TopNavigation.ResetPassword}/:code`,
    element: <ResetPassword />,
  },
]);

export default router;
